export default __webpack_public_path__ + "static/Merriweather-Bold-a594be901209963b0f03a92872b064f0.woff";